
import { Vue, Component, Prop, Ref } from "vue-property-decorator";
import BgNavPage from "@/components/bg-nav-page/index.vue";
import BgNavPageItem from "@/components/bg-nav-page-item/index.vue";
import FileUploader from "@/components/file-uploader/index.vue";
import ColorPanel from "@/components/colorPanel/index.vue";
import SizePanel from "@/components/sizePanel/index.vue";
import { getNewProductType } from "@/service/ewold/api/newProduct";
import { NewProductCategoryOption } from "@/service/supplier-meta/entity/NewProductCategoryOption";
import { CascaderNode } from "element-ui/types/cascader-panel";
import { Cascader } from "element-ui/types";
import { SelectOption } from "@/service/common/entity/SelectOption";
import {
  getNewProductDetail,
  GetNewProductDetailResponse,
} from "@/service/yttCodegen/ewold/api/newProduct";
import {
  getNewProductPropertyByNewProductId,
  GetNewProductPropertyByNewProductIdResponse,
} from "@/service/yttCodegen/ewold/api/newProductProperty";
// import { isClothingCategory } from "@/service/supplier-meta/common/supplier-info-service";
type NotOption<T> = {
  [K in keyof T]-?: T[K] extends undefined ? never : T[K];
};
type PropertyItem =
  NotOption<GetNewProductPropertyByNewProductIdResponse>["result"][number];
enum newProductTypeEnum {
  /** 电子类 */
  electronic = 0,
  /** 服装类 */
  clothing = 1,
  /** 其他 */
  other = 2,
}
@Component({
  components: {
    BgNavPage,
    BgNavPageItem,
    FileUploader,
  },
})
export default class NewProdDetail extends Vue {
  @Ref("fileUploader") fileUploader!: FileUploader;
  @Ref("categoryCascader") categoryCascader!: {
    getCheckedNodes: () => CascaderNode<Node, NewProductCategoryOption>[];
  } & Cascader;
  @Ref("colorPanel") colorPanel!: ColorPanel;
  @Ref("sizePanel") sizePanel!: SizePanel;
  labelWidth = "10em";
  newProductTypeOptions: SelectOption[] = [];
  get isElectronicProductType() {
    return this.remoteData?.new_product_type === newProductTypeEnum.electronic;
  }
  // isClothingCategory = false;
  loading = false;
  loadingPOA = false;
  remoteData: GetNewProductDetailResponse["result"] = {};
  propertyData: PropertyItem[] = [];
  get featureLabels(): { key: number; value: string }[] {
    let res: { key: number; value: string }[] = [];
    if (this.remoteData?.thirdparty_feature_callout) {
      try {
        res = JSON.parse(this.remoteData?.thirdparty_feature_callout);
      } catch (err) {
        res = [];
      }
    }
    return res;
  }
  get mainImages() {
    return this.remoteData?.picture_url?.map((ele) => ele.picture_url) || [];
  }
  get attachments() {
    return (this.remoteData?.attachment || []).map((ele) => ({
      name: ele.file_name,
      url: ele.file_path,
    }));
  }
  get newProductType() {
    return (
      this.remoteData?.new_product_type !== undefined &&
      this.newProductTypeOptions.find(
        (ele) => ele.value === this.remoteData?.new_product_type
      )?.label
    );
  }
  get isClothingProductType() {
    return this.remoteData?.new_product_type === newProductTypeEnum.clothing;
  }
  get seasonLabels(): string[] {
    let res = [];
    if (this.remoteData?.thirdparty_season_label_name) {
      try {
        const list = JSON.parse(this.remoteData?.thirdparty_season_label_name);
        if (Array.isArray(list)) {
          res = list.map((ele) => ele.value);
        }
      } catch (err) {
        res = [];
      }
    }
    return res;
  }
  get suitableAages(): string[] {
    let res = [];
    if (this.remoteData?.thirdparty_suitable_age_name) {
      try {
        const list = JSON.parse(this.remoteData?.thirdparty_suitable_age_name);
        if (Array.isArray(list)) {
          res = list.map((ele) => ele.value);
        }
      } catch (err) {
        res = [];
      }
    }
    return res;
  }
  get propGroups() {
    let groups = [];
    if (
      Array.isArray(this.remoteData?.etc_property_descriptions) &&
      this.remoteData?.etc_property_descriptions.length
    ) {
      const otherProps = {
        name: "其他",
        props: (this.remoteData?.etc_property_descriptions || []).map(
          (ele: { key?: string; value?: string }) => ({
            label: ele.key,
            value: ele.value,
          })
        ),
      };
      groups.push(otherProps);
    }
    return groups;
  }
  async mounted() {
    this.getOptions();
    this.getDetail();
  }
  async getDetail() {
    this.loading = true;
    getNewProductDetail({
      id: this.$route.params.id,
    }).then((res) => {
      this.loading = false;
      if (res.is_success && res.result) {
        this.remoteData = Object.freeze(res.result);
      }
    });
    this.loadingPOA = true;
    getNewProductPropertyByNewProductId({
      new_product_id: this.$route.params.id,
    }).then((res) => {
      this.loadingPOA = false;
      if (res.is_success && Array.isArray(res.result)) {
        this.propertyData = Object.freeze(res.result) as PropertyItem[];
      }
    });
  }
  isLink(str: string) {
    return str && /^http[s]?:/.test(str);
  }
  poaDefImg(row: PropertyItem) {
    return Array.isArray(row.image_list)
      ? row.image_list.find((ele) => ele.is_default)?.picture_url
      : "";
  }
  getOptions() {
    getNewProductType().then((res) => {
      if (Array.isArray(res.result)) {
        this.newProductTypeOptions = res.result.map((ele) => ({
          label: ele.value,
          value: ele.key,
        }));
      }
    });
  }

  close() {
    this.$emit("close");
  }
}
